import { Outlet, useLocation, useNavigate } from "react-router-dom";
import posthog from "posthog-js";
import { useEffect, useRef } from "react";

import { SettingsPageHeader } from "./Header";
import { SETTINGS_TABS } from "./constants";

import { PageWrapper } from "@/components/UnifiedRegistry/BreadcrumbsPageWrapper";

const getSettingsTitle = (pathname: string) => {
  const pathSegment = pathname.split("/").pop();

  const foundTab = SETTINGS_TABS.find(t => t.path === pathSegment);

  if (foundTab) {
    return foundTab.panelTitle;
  }

  for (const parentTab of SETTINGS_TABS) {
    if (parentTab.subTabs) {
      const subTab = parentTab.subTabs.find(sub => sub.path === pathSegment);

      if (subTab) {
        return subTab.panelTitle;
      }
    }
  }

  return "Settings";
};

const getSettingsDescription = (pathname: string) => {
  const pathSegment = pathname.split("/").pop();

  const foundTab = SETTINGS_TABS.find(t => t.path === pathSegment);

  if (foundTab) {
    return foundTab.panelDescription;
  }

  for (const parentTab of SETTINGS_TABS) {
    if (parentTab.subTabs) {
      const subTab = parentTab.subTabs.find(sub => sub.path === pathSegment);

      if (subTab) {
        return subTab.panelDescription;
      }
    }
  }

  return "Manage your settings.";
};

const Settings = () => {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!hasTracked.current) {
      posthog.capture("Settings Page Viewed", {
        name: "Settings",
        href: window.location.href,
      });
      hasTracked.current = true;
    }
  }, []);

  const location = useLocation();
  const endsWithNothing =
    location.pathname.endsWith("/settings") || location.pathname.endsWith("/settings/");
  const navigate = useNavigate();

  useEffect(() => {
    if (endsWithNothing) {
      navigate("billing");
    }
  }, [endsWithNothing, navigate]);

  return (
    <PageWrapper className="flex h-full flex-col">
      <SettingsPageHeader
        title={getSettingsTitle(location.pathname)}
        description={getSettingsDescription(location.pathname)}
      />
      <div className="flex-1 overflow-auto pb-6">
        <Outlet />
      </div>
    </PageWrapper>
  );
};

export default Settings;
